export function PxToVx(pixels: number, ViewSize: number, unit: string) {
  const value = (pixels * 100) / ViewSize;
  return `${value}${unit}`;
}
